export default "__VITE_ASSET__DuOwwGub__"